import { isElectron, isDev } from '../constant';
export default {
	data(){
		return {
			isElectron,
			isDev
		}
	}
}